import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#4D4FAF',
    backgroundColor: '#ffffff',
    opacity: '0.85!important',
    position: ({ position }: { position: TPosition }) => position,
  },
  circularProgress: {
    width: 'unset !important',
    height: 'unset !important',
  },
}));

type TPosition = 'absolute' | 'fixed' | 'relative';

interface IProp {
  position?: TPosition;
}

export const OverlayLoader: React.FC<IProp> = ({ position = 'absolute' }) => {
  const classes = useStyles({ position });

  return (
    <Backdrop className={classes.backdrop} open>
      <CircularProgress className={classes.circularProgress} data-testid='loader' />
    </Backdrop>
  );
};
